<template>
  <div class="commercial-content">
    <div class="commercial" v-if="displayType === 'commercial'">
      <div class="figure">
        <img src="../../../assets/risk/commercial.png" alt="" />
      </div>
      <div class="text-1">
        {{ isPerson && !isShopLevel ? '符合商用用途' : '符合企业商用用途' }}
      </div>
      <div class="text-2">
        {{
          isPerson && !isShopLevel
            ? '您是会员，制作的视频可用于商业用途，'
            : '您是企业会员，制作的视频可用于企业商业用途，'
        }}
      </div>
      <div class="text-3">
        {{ '请放心使用~' }}
      </div>
    </div>
    <div class="learn" v-if="displayType === 'learn' || displayType === 'risk'">
      <template v-if="displayType === 'learn' || hasRisk">
        <div class="title">仅供个人学习交流使用</div>
        <div class="section">
          <div class="text">
            <span>如需用于企业商业用途，请</span
            ><span class="link" @click="openUserBuy()">升级会员</span>
          </div>
        </div>
        <!-- <div class="section" v-if="false">
          <div class="text text-1">
            <template v-if="hasRisk && !isPoor">
              1. 如不用于{{
                isEenterprise ? '企业' : '个人'
              }}商业用途，直接导出即可
            </template>
            <template v-else>
              <span>1. 如需用于个人商业用途，请</span
              ><span class="link" @click="link('/pricing/vipsolo')"
                >升级个人VIP</span
              >
            </template>
          </div>
          <div class="text">
            <template v-if="hasRisk && !isPoor">
              2. 如需用于{{
                isEenterprise ? '企业' : '个人'
              }}商业用途，需替换或删除不可商用素材
            </template>
            <template v-else>
              <span>2. 如需用于企业商业用途，请</span
              ><span class="link" @click="link('/pricing')">升级企业VIP</span>
            </template>
          </div>
        </div> -->
      </template>

      <template v-else-if="displayType === 'learn' && (['basic', 'person'].includes(UserLevelInfo.levelName)) && !hasRisk">
        <div class="title">仅供个人学习交流使用</div>
        <div class="section">
          <div class="text text-1" v-if="false">
            <span>1. 如需用于个人商业用途，请</span
            ><span class="link" @click="link('/pricing/vipsolo')"
              >升级个人VIP</span
            >
          </div>
          <div class="text">
            <span>如需用于企业商业用途，请</span
            ><span class="link" @click="openUserBuy()">升级会员</span>
          </div>
        </div>
      </template>

      <div class="section" style="margin-top: 10px" v-if="hasRisk">
        <div class="text">
          <!-- 存在无法判断版权的素材，不影响视频制作，但无法获得商用授权证书。 -->
          来画平台提供的带有会员可商用标识的模板素材可商用。本地上传的素材如用于商业用途，需自行与版权方确认
        </div>
        <div
          class="link"
          @click="link($getWikiLink('https://wiki.laihua.com/shouquan/shouquan.html'))"
          style="color: #333; border-color: #333"
        >
          如何获取商用授权书？
        </div>
      </div>

      <div class="figure" v-if="displayType === 'learn' && !hasRisk">
        <img src="../../../assets/risk/learn.png" alt="" />
      </div>
      <template v-if="AIGCRisks.length">
        <div class="risk-title">
          <span>由AI生成的不可商用素材（{{ (AIGCRisks && AIGCRisks.length) || 0 }}个）</span>
          <a
            href="https://support.qq.com/products/408104/faqs/134966"
            target="_blank"
          >查看说明</a>
        </div>
        <div class="panel">
          <div
            class="risk-item"
            v-for="(riskItem, i) in AIGCRisks"
            :key="riskItem.id + i"
          >
            <RiskItem :info="riskItem" ref="riskItem"></RiskItem>
          </div>
        </div>
      </template>
      <template v-if="normalRisks.length">
        <div class="risk-title">
          无法判断商用授权素材（{{ (normalRisks && normalRisks.length) || 0 }}个）
        </div>
        <div class="panel">
          <div
            class="risk-item"
            v-for="(riskItem, i) in normalRisks"
            :key="riskItem.id + i"
          >
            <RiskItem :info="riskItem" ref="riskItem"></RiskItem>
          </div>
        </div>
      </template>
    </div>
    <div class="shim"></div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import RiskItem from './riskItemLite';
export default {
  components: {
    RiskItem
  },
  data () {
    return {
      displayType: 'risk',
      items: []
    }
  },
  computed: {
    ...mapGetters([
      'IsVipSprites',
      'TOOL',
      'isPoor',
      'isSolo',
      'isTmpSolo',
      'isEenterprise',
      'CommercialRisk',
      'UserLevelInfo',
      'UserMsg'
    ]),
    isPerson () {
      return this.isSolo || this.isTmpSolo
    },
    hasRisk () {
      return this.items && this.items.length
    },
    isShopLevel () {
      const userMsg = this.UserMsg;
      const ret = userMsg.levelType === 0 && userMsg.level > 0 && userMsg.levelNewType === 6;
      return ret;
    },
    normalRisks () {
      return this.items.filter(v => v.typeName !== 'AIGC');
    },
    AIGCRisks () {
      return this.items.filter(v => v.typeName === 'AIGC');
    }
  },
  watch: {
    "CommercialRisk" (val = []) {
      this.classifyItems(val);
    },
    hasRisk (val, old) {
      if (old && !val) {
        this.handleDisplayType();
      }
    }
  },
  created () {
    this.classifyItems(this.CommercialRisk);
    this.handleDisplayType();
    this.$bus.on('riskDropShow', this.riskDropShow);
  },
  beforeDestroy () {
    this.$bus.off('riskDropShow', this.riskDropShow);
  },
  methods: {
    openUserBuy () {
      this.$memberGuide({
        show: true,
        context: this,
        funcRight: {
          type: "",
          name: "",
        },
        link: 'buyEnterpriseVip'
      });
    },
    riskDropShow () {
      this.classifyItems(this.CommercialRisk);
      this.handleDisplayType();
      this.updateItems();
    },
    handleDisplayType () {
      const isPersonOrLower = ['basic', 'person'].includes(this.UserLevelInfo.levelName);
      if (!this.hasRisk) {
        this.displayType = isPersonOrLower ? 'learn' : 'commercial';
        if (this.isShopLevel) {
          this.displayType = 'commercial';
        }
      } else if (isPersonOrLower) {
        this.displayType = 'learn';
      } else {
        this.displayType = 'risk';
      }

      if (this.isShopLevel) {
        if (!this.hasRisk) {
          this.displayType = 'commercial';
        }
      }
      if (this.UserLevelInfo.trial) {
        this.displayType = 'learn';
        if (this.hasRisk) {
          this.displayType = 'risk';
        }
      }
    },
    link (href) {
      if (href.indexOf('/pricing') == 0) {
        this.$util.localStorage.set('sensorWebPurchaseVipSource', {
          val: {
            routename: 'tool',
            page: '编辑器-商用权限提示'
          }
        });
        this.$util.localStorage.set('sensorWebPayVipSource', {
          val: {
            routename: 'tool',
            page: '编辑器-商用权限提示'
          }
        });
        this.$util.localStorage.set('saPurchaseSource', {
          fullPath: '/tool'
        });
      }
      let a = document.createElement('a');
      a.target = '_blank';
      a.href = href;
      a.click();
    },
    classifyItems (list) {
      let sortFn = (f, s) => {
        let a = f.id;
        let b = s.id;
        return a > b ? 1 : b > a ? -1 : 0;
      };
      list = [...list]
      let temp = [];
      (this.TOOL.sprites || []).forEach((scene) => {
        let p = list.filter((item) => item.scenesId === scene.id) || [];
        p = p.sort(sortFn);
        temp.push(p)
      });
      let gs = list.filter((item) => !item.scenesId || (item.scenesId && item.scenesId.length < 36)) || [];
      let temp2 = [...gs];
      temp.forEach((item) => {
        temp2 = [...temp2, ...item];
      });
      this.items = temp2;
    },

    updateItems () {
      let riskItems = this.$refs.riskItem;
      if (riskItems && riskItems.length) {
        riskItems.forEach(async v => {
          await v.loadSprite();
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.commercial-content {
  cursor: default;
}
.commercial {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  & > .figure {
    margin-top: 40px;
    width: 147px;
    height: 100px;
  }
  & .text-1 {
    font-weight: bold;
    margin-top: 3px;
    margin-bottom: 10px;
  }
  & .text-2 {
    margin-bottom: 10px;
  }
}
.risk-item {
  margin-top: 10px;
  &:first-of-type {
    margin-top: 0;
  }
  &:nth-of-type(2) {
    margin-top: 0;
  }
}
.learn {
  & .title {
    padding: 16px 20px 10px;
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    line-height: 1;
    color: #f79421;
  }
  & .section {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    width: 320px;
    min-height: 60px;
    padding: 0 15px;
    margin: auto;
    background: #f9faff;
    border-radius: 4px;
    font-size: 12px;
    & .link {
      color: #2f58fe;
      border-bottom: 1px #2f58fe solid;
      cursor: pointer;
    }
  }
  & .text-1 {
    margin-bottom: 10px;
  }
  & .figure {
    width: 130px;
    height: 109px;
    margin: auto;
    margin-top: 18px;
  }
  .risk-title {
    display: flex;
    justify-content: space-between;
    font-size: 12px;
    font-weight: bold;
    padding: 16px 20px 10px;
  }
  .panel {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    width: 320px;
    background: #f9faff;
    border-radius: 4px;
    padding: 12px;
    padding-right: 0;
    margin: auto;
  }
  & .risk-item {
    width: 146px;
    &:nth-child(odd) {
      margin-right: 5.5px;
    }
  }
}
.shim {
  height: 20px;
}
img {
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/topnav/riskDrop/commercial.vue